document.addEventListener('DOMContentLoaded', function () {
    // Check if dvh is supported, if not apply fallback
    applyDvhFallback();

    const playRealGameButton = document.querySelector('.game-outer-container .play-real-game-btn');
    if (playRealGameButton) {
        playRealGameButton.addEventListener('click', function (event) {
            event.preventDefault();
            startGame('REAL');
        });
    }

    const playFunGameButton = document.querySelector('.game-outer-container .play-fun-game-btn');
    if (playFunGameButton) {
        playFunGameButton.addEventListener('click', function (event) {
            event.preventDefault();
            startGame('FUN');
        });
    }

    const playRegisterButton = document.querySelector('.game-outer-container .play-register-btn');
    if (playRegisterButton) {
        playRegisterButton.addEventListener('click', function (event) {
            event.preventDefault();
            const registerUrl = playRegisterButton.getAttribute('href');
            if (registerUrl) {
                window.location.href = registerUrl;
            }
        });
    }

    const autoPlayRealGame = document.querySelector('.game-outer-container .play-auto-game');
    if (autoPlayRealGame) {
        startGame('REAL');
    }
});

function getClientDeviceType() {
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const width = Math.min(window.screen.width, window.screen.height);

    if (!hasTouch) return 'desktop';

    if (width <= 1200) return 'mobile';
    if (width <= 1280) return 'tablet';
    return 'desktop';
}

function startGame(mode = 'FUN') {

    const language = getLanguageFromUrl(); // Get the language from the URL

    var data = {
        'action': 'bb_start_game',
        'game_slug': playGameData.game_slug,
        'nonce': playGameData.nonce,
        'mode': mode,
        'language': language
    };

    jQuery.post({
        url: playGameData.ajaxUrl,
        method: 'POST',
        data: data,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('Cf-Device-Type', getClientDeviceType());
        },
        success: function (response) {
            if (!response.success) {
                return;
            }
            if (!response.data || !response.data.game_uri) {
                return;
            }

            // Hide the buttons
            const buttonsWrapper = document.querySelector('.game-outer-container .play-game-buttons-wrapper');
            if (buttonsWrapper) {
                buttonsWrapper.style.display = 'none';
            }

            // Hide the game placeholder
            const gamePlaceholder = document.getElementById("gamePlaceholder");
            if (gamePlaceholder) {
                gamePlaceholder.style.display = "none";
            }

            const gameIframe = document.getElementById("gameIframe");
            if (gameIframe) {
                gameIframe.src = response.data.game_uri;
            }
        },
        error: function (xhr, status, error) {
            console.error('Error:', error);
        }
    });
}

// Get language from URL
function getLanguageFromUrl() {
    // Extract language from URL
    const url = new URL(window.location.href);
    const path = url.pathname.split('/');
    const availableLanguages = {
        'es': 'es_ES',
        'de': 'de_DE',
        'it': 'it_IT',
        'pt': 'pt_PT',
        'fr': 'fr_FR'
    };
    let language = 'en_US'; // default language
    if (availableLanguages.hasOwnProperty(path[1])) {
        language = availableLanguages[path[1]];
    }
    return language;
}

// Apply fallback for browsers that don't support dvh
function applyDvhFallback() {
    // Test if dvh is supported using CSS.supports() API
    const isDvhSupported = CSS.supports('height', '1dvh');

    if (!isDvhSupported) {
        const gameContainer = document.querySelector('.game-outer-container .game-container');
        if (gameContainer) {
            // Apply fallback based on screen size
            const applyHeight = () => {
                const width = window.innerWidth;
                const vh = window.innerHeight * 0.01;

                if (width >= 992) { // lg breakpoint
                    gameContainer.style.height = `calc(${vh * 100}px - 140px)`;
                } else if (width >= 768) { // md breakpoint
                    gameContainer.style.height = `calc(${vh * 100}px - 120px)`;
                } else { // mobile
                    gameContainer.style.height = `calc(${vh * 100}px - 70px)`;
                }
            };

            // Apply on load
            applyHeight();

            // Reapply on resize and orientation change
            window.addEventListener('resize', applyHeight);
            window.addEventListener('orientationchange', applyHeight);
        }
    }
}

